import {StoreConfigPaymentMethodApi} from "../../Api/types";

class CartHelper {

    static isOpen(order: any) {
        if (order.status === 'CONFIRMED' && (order.payment_status === "OPEN" || order.payment_status === "FAILURE")) {
            return true;
        }
        return false;
    }

    static isConfirmed(order: any) {
        if (order.status === 'CONFIRMED' && (order.payment_status === "OPEN" || order.payment_status === "FAILURE")) {
            return true;
        }
        return false;
    }

    static getItemName(items: any, id: any, name: any) {
        let obj = items.filter((item: any) => item.id === id)[0];
        if (obj) {
            return obj.translation.name;
        }
        return name;
    }

    static getAvailablePaymentMethods(storePaymentMethods: StoreConfigPaymentMethodApi[], orderType?: string) {
        const availablePaymentMethods = orderType ? storePaymentMethods.filter(x => {
            return x.order_types === undefined || x.order_types.length === 0 || x.order_types.includes(orderType);
        }) : [...storePaymentMethods];
        return availablePaymentMethods.sort((a, b) => {
            if (a.gateway === 'TPAY' && b.gateway !== 'TPAY') return -1;
            if (a.gateway !== 'TPAY' && b.gateway === 'TPAY') return 1;
            return 0;
        });
    }

    static getDefaultPaymentMethodId(paymentMethodId: any, paymentMethods: StoreConfigPaymentMethodApi[]) {
        let paymentMethod = undefined;

        if (paymentMethodId) {
            paymentMethod = paymentMethods.filter((x: any) => x.id === paymentMethodId)[0];
        }
        if (paymentMethod === undefined) {
            if (paymentMethods.length === 1) {
                paymentMethod = paymentMethods[0];
            }
        }
        if (paymentMethod === undefined) {
            return undefined;
        }
        return paymentMethod.id;
    }
}


export default CartHelper;